import { Plugin } from './Plugin';
import { LightingHelper } from '../helpers';
import { Object3D } from 'three';

export class LightingPlugin extends Plugin{
	constructor(manager){
		super(manager);
		this.lights = new Map();

		this._visible = true;
	}

	get visible(){ return this._visible; }
	set visible(visible){
		this.lights.forEach(light => light.visible = visible);
	}

	setLight(config, pivot = null){
		let light = LightingHelper.createLight(config, this.lights.get(config.name));
		this.lights.set(light.name, light);
		this.viewer.rendering.scene.add(light);
		this.viewer.requestRender();
	}

	removeLight(name){
		if(this.lights.has(name)){
			let light = this.lights.get(name);
			this.lights.delete(name);
			this.viewer.rendering.scene.remove(light);
			this.viewer.requestRender();
		}
	}

	update(){

		// let config = [];

		// // let config = [];
		// let lightNames = new Set();
		// if(config){
		// 	config.forEach(lightConfig => {
		// 		lightNames.add(lightConfig.name);
		// 		this.setLight(lightConfig);
		// 	});
		// }

		// this.lights.forEach(light => {
		// 	if(!lightNames.has(light.name))
		// 		this.removeLight(light.name);
		// });
	}

}